import { apiClient } from './api-client';
import { ApiResponse, ExamSubject, ListExamSubjectsResponse } from '../types';

export class ExamSubjectService {
  
  static async getExamSubjectsByExamId(examId: number): Promise<ListExamSubjectsResponse> {
    try {
      const response = await apiClient.get<ApiResponse<ListExamSubjectsResponse>>(`/exam-subjects/exam/${examId}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching exam subjects:', error);
      throw error;
    }
  }

  static async getExamSubjectById(id: number): Promise<ExamSubject> {
    try {
      const response = await apiClient.get<ApiResponse<ExamSubject>>(`/exam-subjects/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching exam subject:', error);
      throw error;
    }
  }

  static async createExamSubject(subjectData: {
    exam_id: number;
    name: string;
    description?: string;
    weightage?: number;
    display_order?: number;
  }): Promise<ExamSubject> {
    try {
      const response = await apiClient.post<ApiResponse<ExamSubject>>('/exam-subjects', subjectData);
      return response.data.data;
    } catch (error) {
      console.error('Error creating exam subject:', error);
      throw error;
    }
  }

  static async updateExamSubject(id: number, subjectData: {
    name?: string;
    description?: string;
    weightage?: number;
    display_order?: number;
  }): Promise<ExamSubject> {
    try {
      const response = await apiClient.put<ApiResponse<ExamSubject>>(`/exam-subjects/${id}`, subjectData);
      return response.data.data;
    } catch (error) {
      console.error('Error updating exam subject:', error);
      throw error;
    }
  }

  static async deleteExamSubject(id: number): Promise<void> {
    try {
      await apiClient.delete(`/exam-subjects/${id}`);
    } catch (error) {
      console.error('Error deleting exam subject:', error);
      throw error;
    }
  }

  static async reorderExamSubjects(examId: number, subjectOrders: {
    id: number;
    display_order: number;
  }[]): Promise<void> {
    try {
      await apiClient.put('/exam-subjects/reorder', {
        exam_id: examId,
        subject_orders: subjectOrders
      });
    } catch (error) {
      console.error('Error reordering exam subjects:', error);
      throw error;
    }
  }
}